// Importa la librería principal de Prism.js
const Prism = require('prismjs');

// Ejecuta la función para resaltar el código al cargar la página
// document.addEventListener('DOMContentLoaded', highlightCode);
